import gql from 'graphql-tag';

const query = gql`
  query ShippingOptions {
    sale {
      shippingOptions {
        id
        name
        onlyVirtualProducts
        requiresAddress
        price {
          amount
          currency
        }
        freeFromCartValue {
          amount
          currency
        }
        countries {
          code
          name
        }
        isCod
      }
    }
  }
`;

export default query;
